module.exports = __webpack_public_path__ + "static/media/97.0e920999.jpg";